enum CommerceImageType {
  Logo = 1,
  Banner = 2,
  CloverBanner = 3,
  TicketLogo = 4,
  DiscountLogo = 5,
}

export default CommerceImageType;
